<template>

	<div class="main">
		<div class="zz" v-if="showHistoryDialog||showDateTimePicker"
			@click="showHistoryDialog=false;showDateTimePicker=false">

		</div>
		<div class="container">
			<!-- 头部定位与搜索 -->
			<div class="header">
				<div class="location">
					<div class="top">
						发布零工需求消息
						<el-button type="primary" class="history-btn" @click="showHistory">发布历史</el-button>
					</div>
					<div class="inp">
						<!-- 工作位置 -->
						<div class="inp-con">
							<div class="address-input-wrapper">
								工作位置：<el-input v-model="formattedAddress" size="medium" class="Cinput"
									placeholder="输入工作地址" @focus="showPoiDropdown = true" @input="handleAddressInput"
									@blur="handleInputBlur">
									<template #suffix>
										<span v-if="formattedAddress" class="clear-icon"
											@click.stop="SuseCurrentLocation">
											✖
										</span>
									</template>
								</el-input>
								<!-- POI下拉框 -->
								<div v-if="showPoiDropdown && poiList.length > 0" class="poi-dropdown">
									<div v-for="poi in poiList" :key="poi.id" class="poi-item"
										@mousedown="selectPoi(poi)">
										<div class="poi-name">{{ poi.name }}</div>
										<div class="poi-address">{{ poi.address }}</div>
										<div class="poi-distance">{{ (poi.distance / 1000).toFixed(1) }}km</div>
									</div>
								</div>
								<el-button size="mini" type="primary" @click="useCurrentLocation"
									class="use-current-btn">
									使用当前位置
								</el-button>
							</div>
						</div>

						<!-- 选择工种 -->
						<div class="inp-con">
							<div class="address-input-wrapper">
								选择工种：<el-input v-model="worktypeName" size="medium" class="Cinput"
									placeholder="请输入工种或服务内容" @focus="showWorktypeDropdown = true"
									@input="handleWorktypeInput" @blur="handleWorktypeBlur">
									<template #suffix>
										<span v-if="worktypeName" class="clear-icon" @click.stop="clearWorktype">
											✖
										</span>
									</template>
								</el-input>
								<!-- 工种下拉框 -->
								<div v-if="showWorktypeDropdown" class="worktype-dropdown">
									<!-- 右侧字母索引栏 -->
									<div class="index-bar" @mousedown.prevent>
										<div v-for="letter in availableLetters" :key="letter" class="index-letter"
											:class="{ active: currentLetter === letter }"
											@mousedown.prevent="handleLetterClick(letter)">
											{{ letter }}
										</div>
									</div>

									<!-- 主体内容 -->
									<div class="service-list" ref="serviceList" @scroll="onScroll">
										<div v-for="(services, letter) in filteredServices" :key="letter"
											:id="'letter-' + letter" class="group-section" :data-letter="letter">
											<div class="letter-title" :style="{
                          backgroundColor: colors[(letter.charCodeAt(0) - 64) % 8],
                          position: currentLetter === letter ? 'sticky' : 'relative',
                          top: currentLetter === letter ? '0' : 'auto',
                          zIndex: currentLetter === letter ? 100 : 1
                        }">
												{{ letter }}
											</div>
											<div v-for="service in services" :key="service.id" class="service-text"
												@click="selectWorktype(service)">
												{{ service.name }}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- 工作时间 -->
						<div class="inp-con">
							<div class="address-input-wrapper">
								工作时间：
								<div class="time-input-wrapper" @click="openDateTimePicker">
									<el-input v-model="workTime" size="medium" class="Cinput" placeholder="请选择工作时间"
										readonly :style="{ cursor: 'pointer' }">
										<template #suffix>
											<i class="el-icon-date" style="cursor: pointer;"></i>
										</template>
									</el-input>
								</div>
							</div>
						</div>

						<!-- 发布范围 -->
						<div class="inp-con">
							<div class="address-input-wrapper">
								发布范围：<el-select v-model="workBuff" size="medium" class="Cinput" placeholder="请选择发布范围">
									<el-option label="10公里" value="10"></el-option>
									<el-option label="20公里" value="20"></el-option>
									<el-option label="30公里" value="30"></el-option>
									<el-option label="50公里" value="50"></el-option>
								</el-select>
							</div>
						</div>

						<!-- 联系方式 -->
						<div class="inp-con">
							<div class="address-input-wrapper">
								联系方式：<el-input v-model="phone" size="medium" class="Cinput" placeholder="请输入手机号码"
									@blur="validatePhone">
								</el-input>
							</div>
						</div>

						<!-- 工作价格 -->
						<div class="inp-con">
							<div class="address-input-wrapper">
								工作价格：
								<el-input v-model="pic" size="medium" class="Cinput" placeholder="输入价格"
									:disabled="isNegotiable" @input="validatePrice">
									<template #append>
										<el-checkbox v-model="isNegotiable">面议</el-checkbox>
									</template>
								</el-input>
								元
							</div>
						</div>

						<!-- 工作描述 -->
						<div class="inp-cons">
							<div class="address-input-wrapper1">
								<span>工作描述：</span>
								<el-input v-model="workText" size="medium" class="Cinput" placeholder="请输入工作的内容描述"
									style="width: 35vw;" type="textarea" :autosize="{ minRows: 8, maxRows: 15 }"
									maxlength="1500" show-word-limit>
								</el-input>
							</div>
						</div>

						<!-- 发布按钮 -->
						<div class="inp-conss">
							<el-button type="primary" size="large" @click="publish" class="publish-btn">发布</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 日期时间选择器弹窗 -->
		<div v-if="showDateTimePicker" title="选择用工时间" width="650px" center :show-close="false" class="time"
			:close-on-click-modal="false">
			<div class="datetime-picker-popup">
				<div class="popup-header">
					<span class="popup-title">选择用工时间</span>
					<el-button size="mini" type="primary" class="butmini" @click="bxz">不选择时间</el-button>
					<i class="el-icon-close close-icon" @click="closeDateTimePicker"></i>
				</div>

				<div class="date-section">
					<span class="section-title">选择日期</span>
					<div class="date-scroll">
						<div v-for="(date, index) in Sdate" :key="index" class="date-item"
							:class="{ selected: date.dateStr === Sday }" @click="selectDate(date)">
							<span class="day">{{ date.day }}</span>
							<span class="date">{{ date.date }}</span>
						</div>
					</div>
				</div>

				<div class="time-section">
					<span class="section-title">选择时间</span>
					<div class="time-grid" v-if="seadate && seadate.time">
						<div v-for="(time, index) in seadate.time" :key="index" class="time-item" :class="{
              selected: time.sea,
              disabled: time.disabled
            }" @click="selectTime(time)">
							{{ time.text }}
						</div>
					</div>
				</div>

				<el-button class="confirm-btn" type="primary" @click="confirmDateTime">确定</el-button>
			</div>
		</div>

		<!-- 发布历史弹窗 -->
		<div v-if="showHistoryDialog" title="发布历史" width="800px" center class="history">
			<div class="history-container">
				<div class="history-top">
					用工发布历史数据
					<div class="history-close" @click="showHistoryDialog=false">
						×
					</div>
				</div>
				<div v-if="publishHistory.length === 0" class="empty-history">
					暂无发布历史
				</div>
				<div v-else class="history-list">
					<div v-for="(item, index) in publishHistory" :key="index" class="history-card">
						<div class="history-header">
							<span class="history-time">{{ formatTime(item.timestamp) }}</span>
							<div class="history-actions">
								<el-button size="small" type="primary" @click="rePublish(item)">重新发布</el-button>
								<el-button size="small" type="danger" @click="deleteHistory(index)">删除</el-button>
							</div>
						</div>
						<div class="history-content">
							<span class="history-nr">
								<div class="p">工作位置：</div>{{ item.formattedAddress }}
							</span>
							<span class="history-nr">
								<div class="p">工 种：</div>{{ item.worktypeName }}
							</span>
							<span class="history-nr">
								<div class="p">工作时间：</div>{{ item.workTime }}
							</span>
							<span class="history-nr">
								<div class="p">发布范围：</div>{{ item.workBuff }}公里
							</span>
							<span class="history-nr">
								<div class="p">联系方式：</div>{{ item.phone }}
							</span>
							<span class="history-nr">
								<div class="p">工作价格：</div>{{ item.isNegotiable ? '面议' : item.pic + '元' }}
							</span>
							<div class="history-nr1" v-if="item.workText">
								<div class="p">工作描述：</div>
								{{setleng(item.workText) }}
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>
<script>
	import {
		pinyin
	} from 'pinyin-pro';
	import {
		Getitem
	} from "@/utils/item.js";

	export default {
		data() {
			return {
				location: "定位中...",
				locationDetail: "",
				formattedAddress: '',
				worktypeName: '',
				worktypeId: '',
				amapKey: "e2e653a580ac297a5714ae36ce70e4ea",
				// 新增POI相关数据
				showPoiDropdown: false,
				poiList: [],
				poiSearchTimer: null,
				// 新增工种选择相关数据
				showWorktypeDropdown: false,
				groupedServices: {},
				alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
				currentLetter: 'A',
				colors: [],
				isManualScroll: false,
				lastScrollTime: 0,
				activeThreshold: 150,
				originalServices: {},
				debounceTimer: null,
				isSearching: false,
				isUsingCurrentLocation: true,

				// 表单数据
				workTime: '',
				workText: '',
				pic: '',
				phone: '',
				workBuff: '',
				isNegotiable: false,

				// 弹窗控制
				showDateTimePicker: false,
				showHistoryDialog: false,

				// 发布历史
				publishHistory: [],

				// 定位数据
				locationadd: {},
				sunlocationadd: {},

				// 日期时间选择器数据
				Sdate: [],
				Sday: '',
				seadate: {},
				seaDateTime: '',
				seaTime: ''
			};
		},
		computed: {
			availableLetters() {
				return this.alphabet.filter(letter =>
					this.filteredServices[letter] &&
					this.filteredServices[letter].length > 0
				);
			},
			filteredServices() {
				if (!this.worktypeName.trim()) {
					this.isSearching = false;
					return this.groupedServices;
				}

				const result = {};
				const keyword = this.worktypeName.toLowerCase();

				Object.keys(this.groupedServices).forEach(letter => {
					const filtered = this.groupedServices[letter].filter(service => {
						const serviceName = service.name;
						if (serviceName.toLowerCase().includes(keyword)) {
							return true;
						}
						const fullPinyin = pinyin(serviceName, {
							toneType: 'none'
						}).replace(/\s+/g, '');
						if (fullPinyin.includes(keyword)) {
							return true;
						}
						const initials = pinyin(serviceName, {
							toneType: 'none',
							pattern: 'first',
							type: 'array'
						}).join('');
						if (initials.toLowerCase().includes(keyword)) {
							return true;
						}
						const mixed = serviceName.split('').map(char => {
							const charPinyin = pinyin(char, {
								toneType: 'none'
							});
							return charPinyin.length > 0 ? charPinyin[0].charAt(0) : char;
						}).join('');
						return mixed.toLowerCase().includes(keyword);
					});

					if (filtered.length > 0) {
						result[letter] = filtered;
					}
				});

				if (Object.keys(result).length > 0) {
					this.$nextTick(() => {
						const firstLetter = Object.keys(result).sort()[0];
						this.currentLetter = firstLetter;
						this.isSearching = true;
					});
				} else {
					this.isSearching = false;
				}

				return result;
			}
		},

		watch: {
			worktypeName(newVal) {
				if (this.debounceTimer) clearTimeout(this.debounceTimer);
				this.debounceTimer = setTimeout(() => {
					this.isSearching = true;
					if (!newVal.trim()) {
						this.worktypeId = '';
					}
				}, 300);
			},
			isNegotiable(newVal) {
				if (newVal) {
					this.pic = '';
				}
			},
			showDateTimePicker(newVal) {
				if (newVal) {
					this.initDateTimePicker();
				}
			}
		},
		async created() {
			this.getLocationByIP();
			this.initWorktypeData();
			this.loadPublishHistory();
		},
		methods: {
			// 格式化时间
			formatTime(timestamp) {
				return this.formatDateTime(new Date(timestamp));
			},

			formatDateTime(date) {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');

				return `${year}年${month}月${day}日 ${hours}:${minutes}`;
			},
			setleng(e) {
				if (!e) return
				if (e.length > 100) return `${e.slice(0,100)}...`
				return e
			},

			// 打开日期时间选择器
			openDateTimePicker() {
				this.showDateTimePicker = true;
			},

			// 日期时间选择器方法
			initDateTimePicker() {
				const days = ['今天', '明天', '后天'];
				const weekdays = ['日', '一', '二', '三', '四', '五', '六'];
				const now = new Date();

				this.Sdate = Array.from({
					length: 8
				}, (_, i) => {
					const date = new Date(now);
					date.setDate(now.getDate() + i);
					date.setHours(0, 0, 0, 0);

					const timeOptions = Array.from({
						length: 24
					}, (_, j) => {
						const hour = j;
						return {
							text: `${hour.toString().padStart(2, '0')}:00`,
							value: hour,
							disabled: i === 0 && hour < now.getHours() + 1,
							sea: false
						};
					});

					return {
						day: i < 3 ? days[i] : `周${weekdays[date.getDay()]}`,
						date: `${date.getMonth() + 1}月${date.getDate()}日`,
						fullDate: date,
						dateStr: `${date.getMonth() + 1}月${date.getDate()}日`,
						time: timeOptions
					};
				});

				// 设置默认选中
				if (this.workTime) {
					this.parseWorkTime(this.workTime);
				} else {
					const today = this.Sdate[0];
					this.Sday = today.dateStr;
					this.seadate = today;
				}
			},

			parseWorkTime(workTime) {
				if (!workTime) return;

				try {
					const [datePart, timePart] = workTime.split(' ');
					const [year, month, day] = datePart.split('-').map(Number);
					const [hour] = timePart.split(':').map(Number);

					const targetDate = new Date(year, month - 1, day);
					const dateStr = `${month}月${day}日`;

					this.Sday = dateStr;
					const foundDate = this.Sdate.find(date => date.dateStr === dateStr);
					if (foundDate) {
						this.seadate = foundDate;
						// 选中对应的时间
						foundDate.time.forEach(time => {
							time.sea = time.value === hour;
						});
					}
				} catch (error) {
					console.error('解析工作时间失败:', error);
				}
			},

			selectDate(date) {
				this.seadate = date;
				this.Sday = date.dateStr;
				// 清除之前选中的时间
				this.Sdate.forEach(d => {
					d.time.forEach(t => t.sea = false);
				});
			},

			selectTime(time) {
				if (time.disabled) return;

				// 清除所有时间的选中状态
				this.Sdate.forEach(date => {
					date.time.forEach(slot => {
						slot.sea = false;
					});
				});

				// 设置当前选中时间
				time.sea = true;
			},

			formatDate(date) {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				return `${year}-${month}-${day}`;
			},

			bxz() {
				this.workTime = '';
				this.closeDateTimePicker();
				this.$message.success('已取消时间选择');
			},

			confirmDateTime() {
				const selectedTime = this.seadate.time.find(time => time.sea);
				if (!selectedTime) {
					this.$message.error('请选择具体时间');
					return;
				}

				const formattedDate = this.formatDate(this.seadate.fullDate);
				const formattedTime = `${String(selectedTime.value).padStart(2, '0')}:00:00`;
				this.workTime = `${formattedDate} ${formattedTime}`;
				this.closeDateTimePicker();

			},

			closeDateTimePicker() {
				this.showDateTimePicker = false;
			},

			// 清空工种输入框
			clearWorktype() {
				this.worktypeName = '';
				this.worktypeId = '';
				this.$message.success('已清空工种筛选');
			},

			// 使用当前位置
			useCurrentLocation() {
				this.sunlocationadd = {
					...this.locationadd
				};
				this.formattedAddress = this.locationadd.formattedAddress || '';
				this.isUsingCurrentLocation = true;
				this.$message.success('已切换到当前位置');
			},
			SuseCurrentLocation() {
				this.sunlocationadd = {
					...this.locationadd
				};
				this.formattedAddress = '';
				this.isUsingCurrentLocation = true;
				this.$message.success('已切换到当前位置');
			},

			// 初始化工种数据
			initWorktypeData() {
				let s = Getitem('worktype');
				const allData = s.dataList;
				const flatServices = allData.flatMap(category =>
					category.servicesList.map(service => ({
						id: service.id,
						name: service.services,
						category: category.name
					}))
				);

				this.originalServices = this.groupByPinyinInitial(flatServices);
				this.groupedServices = {
					...this.originalServices
				};
				this.currentLetter = Object.keys(this.groupedServices)[0] || 'A';
				this.colors = ['#1890ff', '#52c41a', '#faad14', '#f5222d', '#722ed1', '#13c2c2', '#eb2f96', '#fa8c16'];
			},

			groupByPinyinInitial(services) {
				const grouped = {};

				services.forEach(service => {
					if (!service?.name) return;

					const initial = pinyin(service.name, {
						pattern: 'first',
						toneType: 'none',
						type: 'array'
					})[0]?.charAt(0).toUpperCase() || '#';

					if (!grouped[initial]) grouped[initial] = [];
					grouped[initial].push(service);
				});

				return Object.keys(grouped).sort().reduce((acc, letter) => {
					acc[letter] = grouped[letter];
					return acc;
				}, {});
			},

			// 工种输入处理
			handleWorktypeInput() {
				// 搜索逻辑已经在computed中处理
			},

			// 工种输入框失去焦点处理
			handleWorktypeBlur() {
				setTimeout(() => {
					this.showWorktypeDropdown = false;
				}, 300);
			},

			// 选择工种
			selectWorktype(service) {
				this.worktypeName = service.name;
				this.worktypeId = service.id;
				this.showWorktypeDropdown = false;

			},

			// 字母点击处理
			handleLetterClick(letter) {
				if (!this.filteredServices[letter]) return;

				this.isManualScroll = true;
				this.currentLetter = letter;

				const element = document.getElementById('letter-' + letter);
				if (element && this.$refs.serviceList) {
					this.$refs.serviceList.scrollTop = element.offsetTop - this.$refs.serviceList.offsetTop;
				}

				setTimeout(() => {
					this.isManualScroll = false;
				}, 800);
			},

			// 滚动处理
			onScroll(e) {
				if (this.isSearching) {
					this.isSearching = false;
					return;
				}

				const now = Date.now();
				if (now - this.lastScrollTime < 50) return;
				this.lastScrollTime = now;

				if (this.isManualScroll) return;

				const scrollTop = this.$refs.serviceList ? this.$refs.serviceList.scrollTop : 0;
				const sections = this.$refs.serviceList ? this.$refs.serviceList.querySelectorAll('.group-section') : [];
				let activeLetter = '';

				for (let i = 0; i < sections.length; i++) {
					const section = sections[i];
					if (section.offsetTop - scrollTop <= this.activeThreshold) {
						activeLetter = section.dataset.letter;
					} else {
						if (i > 0) {
							activeLetter = sections[i - 1].dataset.letter;
						}
						break;
					}
				}

				if (activeLetter && this.currentLetter !== activeLetter) {
					this.currentLetter = activeLetter;
				}
			},

			// 地址输入处理
			handleAddressInput() {
				if (this.poiSearchTimer) {
					clearTimeout(this.poiSearchTimer);
				}

				if (!this.formattedAddress.trim()) {
					this.poiList = [];
					return;
				}

				this.poiSearchTimer = setTimeout(() => {
					this.searchPoi(this.formattedAddress);
				}, 300);
			},

			// 输入框失去焦点处理
			handleInputBlur() {
				setTimeout(() => {
					this.showPoiDropdown = false;
				}, 200);
			},

			// POI搜索
			async searchPoi(keyword) {
				if (!keyword.trim() || !this.locationadd.lng || !this.locationadd.lat) {
					this.poiList = [];
					return;
				}

				try {
					const response = await fetch(
						`https://restapi.amap.com/v3/assistant/inputtips?keywords=${encodeURIComponent(keyword)}&key=${this.amapKey}&location=${this.locationadd.lng},${this.locationadd.lat}&city=${this.locationadd.city || ''}`
					);

					if (!response.ok) throw new Error('POI搜索请求失败');

					const data = await response.json();

					if (data.status === "1" && data.tips) {
						this.poiList = data.tips
							.filter(poi => poi.location && typeof poi.location === 'string')
							.map(poi => {
								try {
									const [lng, lat] = poi.location.split(',').map(Number);
									return {
										id: poi.id,
										name: poi.name,
										address: (poi.district || '') + (poi.address || ''),
										location: poi.location,
										distance: this.calculateDistance(
											this.locationadd.lng,
											this.locationadd.lat,
											lng,
											lat
										)
									};
								} catch (error) {
									console.error('解析POI坐标失败:', poi.location);
									return null;
								}
							})
							.filter(poi => poi !== null)
							.sort((a, b) => a.distance - b.distance);
					} else {
						this.poiList = [];
					}
				} catch (error) {
					console.error("POI搜索失败:", error);
					this.poiList = [];
				}
			},

			// 计算两点间距离（米）
			calculateDistance(lng1, lat1, lng2, lat2) {
				const R = 6371000;
				const dLat = (lat2 - lat1) * Math.PI / 180;
				const dLng = (lng2 - lng1) * Math.PI / 180;
				const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
					Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
					Math.sin(dLng / 2) * Math.sin(dLng / 2);
				const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
				return R * c;
			},

			async selectPoi(poi) {
				this.formattedAddress = poi.name;
				this.showPoiDropdown = false;
				this.isUsingCurrentLocation = false;

				const [lng, lat] = poi.location.split(',').map(Number);

				try {
					const regeoResponse = await fetch(
						`https://restapi.amap.com/v3/geocode/regeo?location=${lng},${lat}&key=${this.amapKey}&radius=1000&extensions=base`
					);

					if (regeoResponse.ok) {
						const regeoData = await regeoResponse.json();
						if (regeoData.status === "1" && regeoData.regeocode) {
							const comp = regeoData.regeocode.addressComponent;
							this.sunlocationadd = {
								city: comp.city || comp.province || this.sunlocationadd.city,
								district: comp.district || this.sunlocationadd.district,
								township: comp.township || '',
								formattedAddress: poi.name,
								lng: lng,
								lat: lat,
								address: poi.address
							};
						} else {
							this.sunlocationadd = {
								...this.sunlocationadd,
								formattedAddress: poi.name,
								lng: lng,
								lat: lat
							};
						}
					}
				} catch (error) {
					console.error("逆地理编码失败:", error);
					this.sunlocationadd = {
						...this.sunlocationadd,
						formattedAddress: poi.name,
						lng: lng,
						lat: lat
					};
				}

				// this.$message.success(`已切换到位置: ${poi.name}`);
			},

			// 手机号验证
			validatePhone() {
				if (this.phone && !/^1[3-9]\d{9}$/.test(this.phone)) {
					this.$message.error('请输入正确的手机号码');
					this.phone = '';
				}
			},

			// 价格验证
			validatePrice(value) {
				if (value && !/^\d+$/.test(value)) {
					this.$message.error('价格必须为纯数字');
					this.pic = this.pic.replace(/\D/g, '');
				}
			},

			// 显示发布历史
			showHistory() {
				this.loadPublishHistory();
				this.showHistoryDialog = true;
			},

			// 加载发布历史
			loadPublishHistory() {
				const history = localStorage.getItem('publishHistory');
				this.publishHistory = history ? JSON.parse(history) : [];
			},

			// 保存发布历史
			savePublishHistory() {
				localStorage.setItem('publishHistory', JSON.stringify(this.publishHistory));
			},



			// 删除历史记录
			deleteHistory(index) {
				this.publishHistory.splice(index, 1);
				this.savePublishHistory();
				this.$message.success('删除成功');
			},

			// 重新发布
			rePublish(item) {
				this.formattedAddress = item.formattedAddress;
				this.worktypeName = item.worktypeName;
				this.worktypeId = item.worktypeId;
				this.workBuff = item.workBuff;
				this.phone = item.phone;
				this.isNegotiable = item.isNegotiable;
				this.pic = item.pic;
				this.workText = item.workText;

				// 工作时间需要重新选择，所以不自动填充
				this.workTime = '';

				this.showHistoryDialog = false;
				this.$message.success('已填充发布信息，请重新选择工作时间');
			},

			// 发布
			publish() {
				// 验证必填项
				if (!this.formattedAddress) {
					this.$message.error('请填写工作位置');
					return;
				}
				if (!this.worktypeName) {
					this.$message.error('请选择工种');
					return;
				}
				if (!this.workTime) {
					this.$message.error('请选择工作时间');
					return;
				}
				if (!this.workBuff) {
					this.$message.error('请选择发布范围');
					return;
				}
				if (!this.phone) {
					this.$message.error('请填写联系方式');
					return;
				}
				if (!this.isNegotiable && !this.pic) {
					this.$message.error('请填写工作价格或选择面议');
					return;
				}

				// 创建发布记录
				const publishRecord = {
					timestamp: new Date().getTime(),
					formattedAddress: this.formattedAddress,
					worktypeName: this.worktypeName,
					worktypeId: this.worktypeId,
					workTime: this.workTime,
					workBuff: this.workBuff,
					phone: this.phone,
					isNegotiable: this.isNegotiable,
					pic: this.pic,
					workText: this.workText,
					location: this.sunlocationadd
				};

				// 添加到历史记录
				this.publishHistory.unshift(publishRecord);
				this.savePublishHistory();

				// 清空表单（除工作描述外）
				this.formattedAddress = '';
				this.worktypeName = '';
				this.worktypeId = '';
				this.workTime = '';
				this.workBuff = '';
				this.phone = '';
				this.isNegotiable = false;
				this.pic = '';
				// 工作描述不清空，因为不是必填项

				this.$message.success('发布成功！');
			},

			// IP定位方法
			async getLocationByIP() {
				try {
					const response = await fetch(
						`https://restapi.amap.com/v3/ip?key=${this.amapKey}`
					);

					if (!response.ok) throw new Error(`IP定位请求失败：${response.status}`);

					const data = await response.json();

					if (data.status === "1" && data.city) {
						this.locationadd = {
							province: data.province,
							city: data.city,
							adcode: data.adcode,
							rectangle: data.rectangle,
						};
						this.sunlocationadd = this.locationadd;

						await this.getPOIByRectangle(data.rectangle);
					} else {
						throw new Error("IP定位返回数据异常");
					}
				} catch (error) {
					console.error("IP定位失败:", error.message);
					await this.useDefaultCity();
				}
			},

			// 根据矩形区域获取中心点并进行逆地理编码
			async getPOIByRectangle(rectangle) {
				try {
					if (!rectangle) {
						throw new Error("无矩形区域信息");
					}

					const [bottomLeft, topRight] = rectangle.split(";");
					const [lng1, lat1] = bottomLeft.split(",").map(Number);
					const [lng2, lat2] = topRight.split(",").map(Number);

					const centerLng = (lng1 + lng2) / 2;
					const centerLat = (lat1 + lat2) / 2;

					await this.reverseGeocodeWithPOI(centerLng, centerLat);
				} catch (error) {
					console.error("解析矩形区域失败:", error);
					await this.geocodeByCityName(this.locationadd.city);
				}
			},

			// 逆地理编码获取POI信息
			async reverseGeocodeWithPOI(lng, lat) {
				try {
					const response = await fetch(
						`https://restapi.amap.com/v3/geocode/regeo?location=${lng},${lat}&key=${this.amapKey}&radius=1000&extensions=all&poitype=商务住宅|餐饮服务|购物服务|生活服务|体育休闲服务|医疗保健服务|住宿服务|风景名胜|政府机构及社会团体|交通设施服务|金融保险服务|公司企业|道路附属设施|地名地址信息|公共设施`
					);

					if (!response.ok)
						throw new Error(`逆地理编码请求失败：${response.status}`);

					const data = await response.json();

					if (data.status === "1" && data.regeocode) {
						const comp = data.regeocode.addressComponent;
						const formattedAddress = data.regeocode.formatted_address;
						const pois = data.regeocode.pois || [];

						const detailedAddress = this.removeProvinceCityDistrict(formattedAddress, comp);

						this.location = `${comp.city || comp.province || ""}`;

						if (pois.length > 0) {
							this.locationDetail = `附近：${pois[0].name}`;
						} else {
							this.locationDetail = detailedAddress;
						}

						this.locationadd = {
							city: comp.city || "",
							district: comp.district || "",
							township: comp.township || "",
							formattedAddress: detailedAddress,
							pois: pois.slice(0, 5),
							lng,
							lat
						};
						this.sunlocationadd = this.locationadd;
					} else {
						throw new Error("逆地理编码数据异常");
					}
				} catch (error) {
					console.error("逆地理编码失败:", error.message);
					this.location = this.locationadd.city;
					this.locationDetail = "";
				}
			},

			// 通过城市名称进行地理编码（备用方案）
			async geocodeByCityName(cityName) {
				try {
					const response = await fetch(
						`https://restapi.amap.com/v3/geocode/geo?address=${encodeURIComponent(cityName)}&key=${this.amapKey}`
					);

					const data = await response.json();

					if (data.status === "1" && data.geocodes && data.geocodes.length > 0) {
						const location = data.geocodes[0].location;
						const [lng, lat] = location.split(",").map(Number);
						await this.reverseGeocodeWithPOI(lng, lat);
					} else {
						throw new Error("地理编码失败");
					}
				} catch (error) {
					console.error("地理编码失败:", error);
					this.location = cityName;
					this.locationDetail = "";
				}
			},

			// 备用方案：使用默认城市
			async useDefaultCity() {
				this.location = "北京市";
				const defaultLng = 116.397428;
				const defaultLat = 39.90923;
				await this.reverseGeocodeWithPOI(defaultLng, defaultLat);
			},

			// 去除地址中的省市县信息
			removeProvinceCityDistrict(formattedAddress, comp) {
				if (!formattedAddress) return '';

				let address = formattedAddress;

				if (comp.province && address.startsWith(comp.province)) {
					address = address.substring(comp.province.length);
				}

				if (comp.city && address.startsWith(comp.city)) {
					address = address.substring(comp.city.length);
				}

				if (comp.district && address.startsWith(comp.district)) {
					address = address.substring(comp.district.length);
				}

				address = address.replace(/^[\s、，,]+/, '');

				return address.trim() || formattedAddress;
			}
		}
	};
</script>

<style scoped>
	.main {
		height: 90vh;
		width: 100vw;
		background: #f8f8f8;
		font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
		box-shadow: 10px -5px 2px rgba(0, 0, 0, 0.2);
		margin: 0 auto;
		display: flex;
		justify-content: center;
	}

	.container {
		height: 90vh;
		width: 50vw;
		background: #f8f8f8;
		font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
		box-shadow: -2px 5px 2px rgba(0, 0, 0, 0.2);
		border: 1px solid rgba(0, 0, 0, 0.2);
	}

	.header {
		width: 100%;
		height: 15vh;
		border-bottom: 1px solid #eee;
		display: flex;
	}

	.location {
		width: 100%;
		display: flex;
		flex-direction: column;
		color: #555;
		font-size: 16px;
		font-weight: 900;
		margin-bottom: 20px;
	}

	.top {
		height: 8vh;
		font-size: 25px;
		font-weight: 900;
		text-align: left;
		padding-left: 5px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 5px;
		border-bottom: 1px solid rgba(0, 0, 0, 0.2);
	}

	.history-btn {
		margin-right: 20px;
	}

	.location-tou {
		height: 5vh;
		display: flex;
		justify-content: left;
		align-items: center;
		padding: 0 15px;
		position: relative;
	}

	.inp {
		width: 100vw;
		height: 5vh;
		padding: 0 15px;
		display: flex;
		justify-content: left;
		flex-direction: column;
		gap: 15px;
	}

	.inp-con {
		width: 50vw;
		height: 5vh;
		padding: 0 15px;
		display: flex;
		flex-wrap: nowrap;
		justify-content: left;
		align-items: center;
		gap: 25px;
	}

	.Cinput {
		width: 250px;
	}

	.inp-cons {
		width: 50vw;
		padding: 0 15px;
		display: flex;
		flex-wrap: nowrap;
		justify-content: left;
		align-items: flex-start;
		gap: 25px;
	}

	.inp-conss {
		margin-top: 20px;
		width: 50vw;
		padding: 0 15px;
		display: flex;
		flex-wrap: nowrap;
		justify-content: center;
		align-items: center;
		gap: 25px;
	}

	/* 时间输入框包装器 */
	.time-input-wrapper {
		cursor: pointer;
		display: inline-block;
		width: 250px;
	}

	/* 发布按钮样式 */
	.publish-btn-container {
		display: flex;
		justify-content: center;
		margin-top: 30px;
		padding: 0 15px;
	}

	.publish-btn {
		width: 200px;
		height: 50px;
		font-size: 18px;
	}

	/* 发布历史样式 */
	.history-container {
		max-height: 80vh;

		background-color: #ffffff;
	}

	.empty-history {
		text-align: center;
		color: #999;
		padding: 40px;
		font-size: 16px;
	}

	.history-list {
		max-height: 65vh;
		display: flex;
		flex-direction: column;
		gap: 16px;
		/* justify-content: center; */
		padding-top: 10px;
		padding-bottom: 10px;

		overflow-y: auto;

	}

	.history-card {
		width: 90%;


		margin: 0 auto;
		border: 1px solid #e4e7ed;
		border-radius: 8px;
		padding: 16px;
		background: #fafafa;
		/* margin-top: 10px; */

	}

	.history-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 5px;
		padding-bottom: 5px;
		border-bottom: 1px solid #e4e7ed;
	}

	.history-time {
		font-size: 14px;
		color: #666;
		font-weight: 700;
		color: red;
	}

	.history-actions {
		display: flex;
		gap: 8px;
	}

	.history-content {
		margin: 4px 0;
		font-size: 12px;
		line-height: 30px;
		color: #333;
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;


	}

	.history-nr {
		width: 40%;
		text-align: left;
		display: flex;
	}

	.history-nr1 {
		width: 100%;
		text-align: left;
		display: flex;
		/* gap: 10px; */


	}

	/* 清空图标样式 */
	.clear-icon {
		cursor: pointer;
		color: #c0c4cc;
		font-size: 14px;
		padding: 0 4px;
		transition: color 0.2s;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}

	.clear-icon:hover {
		color: #909399;
	}

	/* POI下拉框样式 */
	.address-input-wrapper {
		position: relative;
		display: flex;
		align-items: center;
		gap: 15px;
	}

	.address-input-wrapper1 {
		display: flex;
		align-items: start;
		gap: 15px;
	}

	.poi-dropdown {
		position: absolute;
		top: 100%;
		left: 0;
		right: 0;
		background: white;
		border: 1px solid #e4e7ed;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		max-height: 400px;
		overflow-y: auto;
		z-index: 2000;
		margin-top: 4px;
	}

	.poi-item {
		padding: 8px 12px;
		cursor: pointer;
		border-bottom: 1px solid #f0f0f0;
		transition: background-color 0.2s;
	}

	.poi-item:last-child {
		border-bottom: none;
	}

	.poi-item:hover {
		background-color: #f5f7fa;
	}

	.poi-name {
		font-size: 14px;
		font-weight: 500;
		color: #333;
		margin-bottom: 2px;
		text-align: left;
	}

	.poi-address {
		font-size: 12px;
		color: #666;
		margin-bottom: 2px;
		text-align: left;
	}

	.poi-distance {
		font-size: 11px;
		color: #999;
		text-align: right;
	}

	/* 工种下拉框样式 */
	.worktype-dropdown {
		position: absolute;
		top: 100%;
		left: 0;
		right: 0;
		background: white;
		border: 1px solid #e4e7ed;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		max-height: 500px;
		overflow: hidden;
		z-index: 2000;
		margin-top: 4px;
		display: flex;
		flex-direction: column;
	}

	.index-bar {
		position: absolute;
		right: 10px;
		top: 10px;
		bottom: 10px;
		z-index: 150;
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 30px;
		background: rgba(255, 255, 255, 0.9);
		border-radius: 15px;
		padding: 5px 0;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		pointer-events: auto;
	}

	.index-letter {
		font-size: 12px;
		padding: 2px 0;
		color: #666;
		cursor: pointer;
		width: 100%;
		text-align: center;
	}

	.index-letter.active {
		color: red;
		font-weight: bold;
	}

	.service-list {
		flex: 1;
		height: 400px;
		overflow-y: auto;
		padding: 10px;
		position: relative;
	}

	.group-section {
		margin-bottom: 20px;
	}

	.letter-title {
		font-size: 16px;
		font-weight: bold;
		color: white;
		background-color: #1890ff;
		padding: 8px 15px;
		border-radius: 4px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}

	.service-text {
		font-size: 14px;
		padding: 8px 0;
		color: #444;
		border-bottom: 1px solid #f0f0f0;
		margin-left: 15px;
		cursor: pointer;
		transition: background-color 0.2s;
		text-align: left;
	}

	.service-text:hover {
		background-color: #f5f7fa;
	}

	/* 日期时间选择器样式 */
	.datetime-picker-popup {
		width: 100%;
		background-color: white;
		border-radius: 8px;
		padding: 20px;
	}

	.popup-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
	}

	.popup-title {
		font-size: 18px;
		font-weight: bold;
	}

	.close-icon {
		font-size: 20px;
		color: #999;
		cursor: pointer;
	}

	.date-section,
	.time-section {
		margin-bottom: 20px;
	}

	.section-title {
		font-size: 16px;
		color: #666;
		margin-bottom: 10px;
		display: block;
	}

	.date-scroll {
		padding: 10px 0;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;

	}

	.date-item {
		display: inline-flex;
		flex-direction: column;
		align-items: center;
		padding: 10px;
		margin: 5px;
		border-radius: 6px;
		background-color: #f5f5f5;
		cursor: pointer;
		min-width: 70px;
		color: #333;
		/* background-color: #1890ff; */
	}

	.date-item.selected {
		background-color: #1890ff;
		color: white;
	}

	.day {
		font-size: 12px;
	}

	.date {
		font-size: 12px;
		font-weight: bold;
	}

	.time-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 10px;
	}

	.time-item {
		padding: 10px;
		text-align: center;
		border-radius: 6px;
		background-color: #f5f5f5;
		cursor: pointer;
		color: #333;
	}

	.time-item.selected {
		background-color: #1890ff !important;
		color: white;
	}

	.time-item.disabled {
		background-color: #e8e8e8;
		color: #ccc;
		pointer-events: none;

	}

	.confirm-btn {
		margin-top: 20px;
		background-color: #1890ff;
		color: white;
		width: 100%;
		height: 40px;
		border: none;
		border-radius: 6px;
		cursor: pointer;
	}

	.butmini {
		font-size: 14px;
		margin-left: 85px;
	}

	.time {
		z-index: 100;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);


	}

	.history {
		z-index: 100;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		min-width: 150px;
		min-height: 150px;
		/* padding-bottom: 15px; */
	}

	.zz {
		position: fixed;
		width: 100vw;
		height: 100vh;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: rgba(0, 0, 0, 0.3);
		z-index: 20;
	}

	/* 	<div class="history-top">
		用工发布历史数据
		<div class="history-close">
			×
		</div>
	</div> */
	.history-top {
		/* min-width: 50vw; */
		height: 5vh;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #333;
		font-weight: 900;
		font-size: 18px;
		position: relative;
		margin-bottom: 10px;
		border-bottom: 1px solid rgba(0, 0, 0, 0.3);

	}

	.history-close {
		position: absolute;
		right: 5px;
		top: 50%;
		transform: translate(-50%, -50%);
		font-size: 25px;
		cursor: pointer;
	}

	.p {
		font-weight: 900;
		width: 70px;
		/* display: flex; */
		text-align: right;
		flex-shrink: 0
	}

	.nrs {
		flex: 1;
	}
</style>